/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable ember/no-new-mixins */
import { computed } from '@ember/object';
import { not, or, readOnly, reads } from '@ember/object/computed';
import Mixin from '@ember/object/mixin';
import { ARTICLES_FEATURE, INBOX_FEATURE, MESSAGES_FEATURE } from 'embercom/lib/billing';
import IntercomradesProductsOverride from 'embercom/lib/intercomrades-products-override';
import localFeatureFlags from 'embercom/lib/local-feature-flags';
import { StandalonePlatform } from 'embercom/objects/standalone/constants';

export const nameForTestFeatureEnabledByGlobalFeatureFlagDefaults =
  '_test-ff-enabled-by-global-defaults';
export const nameForTestFeatureDisabledByGlobalFeatureFlagDefaults =
  '_test-ff-disabled-by-global-defaults';

const generateFeatureFlagConfig = ({ flattenComputed } = { flattenComputed: false }) => {
  let ComputedCanUseFeature;
  if (flattenComputed) {
    ComputedCanUseFeature = (featureKey) => featureKey;
  } else {
    ComputedCanUseFeature = function (featureKey) {
      return computed('features.[]', 'localStorageFeatures.[]', function () {
        return this.canUseFeature(featureKey);
      });
    };
  }
  return {
    //team-data-foundations
    useBulkExportNewUI: ComputedCanUseFeature('bulk-export-new-ui'),
    canUseSamlSso: ComputedCanUseFeature('saml_sso'),
    canUseSamlMultiWorkspaces: ComputedCanUseFeature('rails-dev-platform-saml-multi-workspaces'),
    hasLegacyWebhookAccess: ComputedCanUseFeature('team-data-foundations-legacy-webhook-access'),
    canUseHmacSignature: ComputedCanUseFeature('team-data-foundations-hmac-signature'),
    canUseManualRedaction: ComputedCanUseFeature('tdf-manual-redaction'),
    canUsePlanEditorSearch: ComputedCanUseFeature('embercom-app-serializer-limit-external-plans'),

    //team-actions - procedures workstream
    canUseFinProceduresAllowEmailForLeadsWithoutIdentifiers: ComputedCanUseFeature(
      'fin-procedures-allow-email-for-leads-without-identifiers',
    ),

    //team-actions
    canUseGithubWorkflowsAlpha: ComputedCanUseFeature('github-workflows-alpha'),
    useAppCardApi: ComputedCanUseFeature('marketplace-app-card-api'),
    isExistingAppPartner: ComputedCanUseFeature(
      'app-ecosystem-dev-hub-app-partner-existing-partner',
    ),
    canShowDevHubAppPartner: not('isExistingAppPartner'),
    canUseNewWorkflowsJiraInstallation: ComputedCanUseFeature(
      'team-data-interop-new-workflows-jira-installation-flow',
    ),

    canUseFinWorkflowsStepsInAllWorkflows: ComputedCanUseFeature(
      'fin-workflows-steps-in-all-workflows',
    ),
    canUseFinTaskSimpleMode: ComputedCanUseFeature('team-actions-fin-task-simple-mode'),
    canUseWorkflowsWaitForCallback: ComputedCanUseFeature('team-actions-wait-for-webhook'),
    canUseWorkflowsWaitNoInterruption: ComputedCanUseFeature('workflows-wait-no-interruption'),
    canUseWorkflowsConversationTracingTool: ComputedCanUseFeature(
      'team-workflows-conversation-tracing',
    ),
    canUseAddNoteTool: ComputedCanUseFeature('team-actions-add-note-tool'),
    canUseFinProcedures: ComputedCanUseFeature('fin-procedures'),
    canUseFinProceduresAllowTaskCreation: ComputedCanUseFeature('procedures-allow-task-creation'),
    canUseFinProceduresAllowTaskMigration: ComputedCanUseFeature('procedures-allow-task-migration'),
    canUseFinTaskTemplate: ComputedCanUseFeature('answerbot-fin-task-v3'),
    canUseFinTaskAskAnExpert: ComputedCanUseFeature('team-actions-fin-tasks-ask-an-expert'),
    canUseFinAssignmentFromWorkflows: ComputedCanUseFeature(
      'rd-services-fin-assignment-from-workflows',
    ),
    canUseMonitor: ComputedCanUseFeature('monitor'),
    canSeeMonitor: computed('features.[]', 'localStorageFeatures.[]', function () {
      return (
        this.canUseFeature('monitor') || this.canUseFeature('team-self-serve-ai-insights-addon')
      );
    }),
    slimInsertableActions: ComputedCanUseFeature('team-actions-slim-insertable-actions'),
    canUseResolveConversation: ComputedCanUseFeature('team-actions-resolve-conversation'),
    canUseEmailOtpWorkflow: ComputedCanUseFeature('df-email-otp-workflow'),

    //team-phone
    canUseChannelsVideoCall: ComputedCanUseFeature('channels-video-call'),
    canUseChannelsPhoneCall: ComputedCanUseFeature('channels-phone-call'),
    canUseInboundPhoneCall: ComputedCanUseFeature('inbound-phone-call'),
    canUsePhoneWorkflowTrigger: ComputedCanUseFeature('phone-workflow-trigger'),
    isCallingKillswitchEnabled: ComputedCanUseFeature('ae-calling-killswitch'),
    canFetchUserByPhoneNumber: ComputedCanUseFeature('ae-fetch-user-by-phone-number'),
    canUseDialpad: ComputedCanUseFeature('phone-dev-dialpad'),
    canUsePhoneCsat: ComputedCanUseFeature('phone-csat'),
    callingDropdownKillswitch: ComputedCanUseFeature('calling-dropdown-killswitch'),
    canUseFinVoiceDefaultVoiceLydia: ComputedCanUseFeature('fin-voice-default-voice-lydia'),
    canUseFinVoiceLowPassFilter: ComputedCanUseFeature('fin-voice-low-pass-filter'),
    canUseFinVoiceProceduresInUI: ComputedCanUseFeature('fin-voice-voice-procedures-in-ui'),
    canUsePhoneOneTimePasscodeWorkflowStep: ComputedCanUseFeature('phone-otp-workflow-step'),
    canUseOutboundFinVoiceMvp: ComputedCanUseFeature('outbound-fin-voice-mvp'),
    canUseFinVoiceSip: ComputedCanUseFeature('team-fin-voice-sip'),

    //team-data-foundations
    canUseHistoricalBulkSync: ComputedCanUseFeature('crm-salesforce-bulk-sync'),
    canOptInToSalesforceBeta: ComputedCanUseFeature('dev-platform-salesforce-opt-in-flow'),
    canUseCustomObjectsRequiredAttributes: ComputedCanUseFeature(
      'cdp-custom-objects-required-attributes',
    ),
    canMigrateFromZendesk: ComputedCanUseFeature('cdp-migrate-from-zendesk'),
    canImportFromZendeskNewUi: ComputedCanUseFeature('cdp-import-data-from-zendesk-new-ui'),
    canBypassIdVForFinPersistedDataDemo: ComputedCanUseFeature(
      'answerbot-bypass-idv-for-fin-persisted-data-demo',
    ),

    canListJiraSitesOnJiraIntegrationSettings: ComputedCanUseFeature(
      'team-actions-jira-integration-list-sites',
    ),
    canUseFinTaskV3: ComputedCanUseFeature('answerbot-fin-task-v3'),
    canUseInstructionModelRouting: ComputedCanUseFeature('team-actions-instruction-model-routing'),
    // actions-1-team
    canUseAiAgentWorkflows: ComputedCanUseFeature('answerbot-fin-actions-workflow-write-actions'),

    // team-conversational-knowledge
    canUseCopilotGuidance: ComputedCanUseFeature('answerbot-copilot-guidance'),
    canUseExtractionExternalSources: ComputedCanUseFeature(
      'conversation-extraction-external-sources',
    ),

    canUseScheduledPublishing: ComputedCanUseFeature('team-conv-knowledge-scheduled-publishing'),
    canUseSalesforceArticleSynchroniser: ComputedCanUseFeature(
      'team-conv-knowledge-salesforce-article-synchronizer',
    ),

    // knowledge and data group features
    canUseDedicatedIPs: ComputedCanUseFeature('engage-channels-dedicated-ips'),
    canBumpCSVImportFileSizeLimit: ComputedCanUseFeature(
      'engage-systems-fixed-list-messaging-bump-filesize-limit',
    ),
    canOverrideMobileSmartLinkCondition: ComputedCanUseFeature(
      'group-engage-systems-smart-links-opt-in',
    ),
    canDisableInboundConversations: ComputedCanUseFeature('disable_inbound_conversations'),
    hasSavedContentFeature: ComputedCanUseFeature('macros_with_actions_billing_feature'),
    hasVersioningBillingFeature: ComputedCanUseFeature('ruleset_versioning'),
    canUseSenderRoleFilter: ComputedCanUseFeature('orchestration-sender-role-filter'),
    useCustomerTwilioAccount: ComputedCanUseFeature('orchestration-sms-customer-twilio-account'),
    canUseCustomKeywordResponses: ComputedCanUseFeature(
      'orchestration-sms-custom-keyword-responses',
    ),
    canUseSmsBeta: ComputedCanUseFeature('messages-sms-beta'),
    canUseDelayedAssigneeDropdown: ComputedCanUseFeature(
      'engage-systems-delayed-assignee-dropdown',
    ),
    canUseAlphanumericSenderId: ComputedCanUseFeature('engage-systems-sms-alphanumeric-sender-id'),
    canUseSeriesEmailUnsubscribeLinks: ComputedCanUseFeature(
      'engage-systems-series-email-unsubscribe-links',
    ),
    canUseSeriesMetaData: ComputedCanUseFeature('engage-systems-series-metadata'),
    ccIntercomPages: ComputedCanUseFeature('team-cc-pages'),
    // Context: https://github.com/intercom/intercom/issues/134467
    canUseManualAccountCreation: ComputedCanUseFeature('team-cc-manual-account-creation'),
    canUseMessagePointers: ComputedCanUseFeature('team-oe-message-pointers'),
    checklistRemindersQA: ComputedCanUseFeature('proactive-support-checklists-reminders-qa'),
    canUseReducedMatchSpacingPeriod: ComputedCanUseFeature(
      'proactive-support-reduced-match-spacing-period',
    ),
    canUseApifyAgressivePruning: ComputedCanUseFeature(
      'psg-external-content-apify-aggressive-pruning',
    ),
    canUseExternalContentReadibility: ComputedCanUseFeature(
      'can-use-readability-filter-for-extenal-content',
    ),
    canUseDeletedSurveyResponseStats: ComputedCanUseFeature('psg-deleted-survey-response-stats'),
    canUseContentSegmentRules: ComputedCanUseFeature('team-kf-content-segment-rules'),
    canUsePostsPreview: ComputedCanUseFeature('group-ps-posts-preview'),

    canUseSurveysResponseOrdering: ComputedCanUseFeature('psg-surveys-response-ordering'),
    shouldBypassTlsCutoffDate: ComputedCanUseFeature('tls-bypass-cutoff-date'),
    disableAutoSave: ComputedCanUseFeature('articles-disable-autosave'),
    canUseArticleReviews: ComputedCanUseFeature('article_reviews'),
    canUseChecklistsMultiHcInserters: ComputedCanUseFeature(
      'psg-multi-help-center-checklists-inserters',
    ),
    canUseLargerEmailPanelInSeries: ComputedCanUseFeature('psg-larger-email-panel-series'),
    canUseFinPlayground: ComputedCanUseFeature('answerbot-fin-playground'),
    canUseFinPlaygroundColdStart: ComputedCanUseFeature('fin-playground-cold-start'),
    canUseFinVoiceReactPlayground: ComputedCanUseFeature('fin-voice-react-playground'),
    canUseFinVoicePlaygroundDev: ComputedCanUseFeature('answerbot-fin-voice-playground-dev'),
    canUseFinVoiceRunbooks: ComputedCanUseFeature('answerbot-fin-voice-runbooks'),
    canUseFinVoiceProcedures: ComputedCanUseFeature('fin-voice-procedures'),
    canUseFinVoiceRunbooksOrProcedures: or('canUseFinVoiceRunbooks', 'canUseFinVoiceProcedures'),
    canUseFinVoiceToastRunbooks: ComputedCanUseFeature('answerbot-fin-voice-toast-runbooks'),
    canUseFinVoiceHeliosxOrderTracking: ComputedCanUseFeature(
      'answerbot-fin-voice-heliosx-order-tracking',
    ),
    canSetupFinVoicePhoneEasySetup: ComputedCanUseFeature('phone-fin-voice-easy-setup'),
    canUseMessengerNudges: ComputedCanUseFeature('team-standalone-messenger-nudges'),
    canUseSalesMessenger: ComputedCanUseFeature('team-messenger-sales-messenger'),
    canUseFinSuccessAgentExperimentFinStudio: ComputedCanUseFeature(
      'fin-success-agent-experiment-fin-studio',
    ),
    canUsePhoneDefaultOutboundForCallbacks: ComputedCanUseFeature(
      'phone-default-outbound-for-callbacks',
    ),
    canUseFinVoiceTamilSupport: ComputedCanUseFeature('phone-fin-voice-tamil-support'),
    canUseFinVoiceMultilingual: ComputedCanUseFeature('answerbot-fin-voice-multilingual'),
    canUsePhoneFinVoiceFree: ComputedCanUseFeature('phone-fin-voice-free'),

    canUseFinPlaygroundTopics: ComputedCanUseFeature(
      'answerbot-fin-playground-question-generation-by-topic',
    ),
    canUseFinPlaygroundAudienceTargeting: ComputedCanUseFeature(
      'fin-playground-audience-targeting',
    ),
    canUseFinPlaygroundTestAsSelector: ComputedCanUseFeature('fin-playground-test-as-selector'),
    canUseFinPreviewImpersonationNewLeadOption: ComputedCanUseFeature(
      'fin-preview-impersonation-new-lead-option',
    ),
    canUseFinPlaygroundShowLastModified: ComputedCanUseFeature('fin-playground-show-last-modified'),
    canUseSophisticatedTestingCentralisedPage: ComputedCanUseFeature(
      'sophisticated-testing-centralised-page',
    ),
    canUseFileSourceInCopilot: ComputedCanUseFeature('group-ps-copilot-file-source-content'),
    canUseExternalContentInCopilot: ComputedCanUseFeature('group-ps-copilot-external-content'),
    canSelectConfluenceSubFolder: ComputedCanUseFeature('team-ki-select-confluence-sub-folder'),
    canUseIntegrationAppForSalesforce: ComputedCanUseFeature(
      'team-knowledge-interop-sfdc-integration',
    ),
    canUseDisableNoMarginClassTransformation: ComputedCanUseFeature(
      'team-kf-disable-no-margin-class-transformation',
    ),
    canUseFieldMapperForImportSource: ComputedCanUseFeature(
      'team-knowledge-foundations-import-source-field-mapping',
    ),
    canUseAudienceForCopilot: computed('features.[]', 'localStorageFeatures.[]', function () {
      return !this.canUseFeature('team-kds-copilot-audience-targeting-opt-out');
    }),

    canUseNewWebsiteSync: ComputedCanUseFeature('team-knowledge-foundations-new-website-sync'),
    canShowWebsiteSyncProgress: ComputedCanUseFeature(
      'team-knowledge-foundations-website-sync-progress',
    ),
    canUseRevampPreSync: ComputedCanUseFeature('team-knowledge-foundations-revamp-pre-sync'),
    canEnableFinForInternalArticles: ComputedCanUseFeature(
      'team-knowledge-foundations-enable-fin-internal-articles',
    ),
    canUseNewContentSearchV2: ComputedCanUseFeature(
      'team-knowledge-foundations-new-content-search-v2',
    ),
    canUseZendeskMetadataImporterFlow: ComputedCanUseFeature(
      'team-knowledge-foundations-zendesk-source-metadata-descriptors',
    ),
    canUseConfluenceReactImporter: ComputedCanUseFeature(
      'team-knowledge-foundations-confluence-react-importer',
    ),

    showRegulatoryComplianceCountriesForSMS: ComputedCanUseFeature(
      'ps-regulatory-compliance-countries-for-sms',
    ),
    canUseHelpCenterFooterTextCustomization: ComputedCanUseFeature(
      'team-kds-customizable-help-center-footer-text',
    ),
    canSeeLegacyContentSuggestions: ComputedCanUseFeature(
      'team-knowledge-foundations-legacy-content-suggestions',
    ),

    canUseEventMetadataGoals: ComputedCanUseFeature('psg-event-metadata-matching'),
    canUseArticleResultsShown: ComputedCanUseFeature('kds-can-use-article-results-shown'),

    canUseUnifiedContentUI: computed(
      'canUseStandalone',
      'features.[]',
      'localStorageFeatures.[]',
      function () {
        if (!this.canUseStandalone) {
          return this.canUseFeature('team-knowledge-foundations-content-setup-v2');
        }
        return this.canUseFeature('team-knowledge-foundations-standalone-content-setup-v2');
      },
    ),

    // team-proactive-support
    canUseTourFontProximaNova: ComputedCanUseFeature('outbound-tour-font-proxima-nova'),
    canUseMultipleDomainKeys: ComputedCanUseFeature('ps-multiple-domain-keys'),

    //team-psg-articles
    canUseArticleVersionSteps: ComputedCanUseFeature('articles-version-steps'),
    canUseArticleSuggestions: ComputedCanUseFeature('articles-content-suggestions'),

    //team-email
    canUseTeammateInviteCsvImport: ComputedCanUseFeature('team-email-teammate-invite-csv-import'),
    //team-pricing-and-packaging
    canUsePlanLimits: ComputedCanUseFeature('team-pnp-plan-limits'),
    canUseBulkEditSeats: ComputedCanUseFeature('can-bulk-edit-seats'),
    hasMultipleSeatTypes: ComputedCanUseFeature('multiple_seat_types'),
    hasRoles: ComputedCanUseFeature('role_based_permissions'),
    hasMultipleSeatTypesPaywalled: ComputedCanUseFeature('multiple_seat_types_paywalled'),
    canSeeLastSeenDatesOnTeammateList: ComputedCanUseFeature(
      'can-see-last-seen-dates-on-teammate-list',
    ),
    canSeeBulkWhatsapp: ComputedCanUseFeature('team-pnp-can-see-bulk-whatsapp'),
    canFilterTeammateListDataByLastActive: ComputedCanUseFeature(
      'can-filter-teammate-list-data-by-last-active',
    ),
    canBulkDeleteTeammates: ComputedCanUseFeature('can-bulk-delete-teammates'),
    canUseSelectAllInTeammateList: ComputedCanUseFeature('can-use-select-all-in-teammate-list'),

    cannotAssignWiderAccess: ComputedCanUseFeature('wm-permissions-cannot-assign-wider-access'),

    canUsePerProductPricingFlow: ComputedCanUseFeature('per-product-pricing-flow'),
    canUseArticles: ComputedCanUseFeature(ARTICLES_FEATURE),
    canUseInbox: ComputedCanUseFeature(INBOX_FEATURE),
    canUseMessages: ComputedCanUseFeature(MESSAGES_FEATURE),

    canUseRealTimeSeatUpdates: ComputedCanUseFeature(
      'team-pricing-and-packaging-real-time-seat-usage',
    ),
    hasCopilotSeatType: ComputedCanUseFeature('copilot_seat_type_billing_feature'),
    hasUnlimitedCopilotAccessAddOn: ComputedCanUseFeature(
      'unlimited_fin_ai_copilot_access_billing_feature',
    ),
    canUsePlanPricingMetrics: ComputedCanUseFeature('team-pnp-plan-pricing-metrics'),
    canSkipActiveInvitesLimitCheck: ComputedCanUseFeature('pnp-skip-active-invites-limit-check'),
    isExpiredSubscriptionPageEnabledForDev: ComputedCanUseFeature(
      'team-purchase-experience-expired-subscription-page-enabled-for-dev',
    ),
    canUseSeatOverages: ComputedCanUseFeature('team-sales-led-growth-seat-overages'),
    hasSeatOveragesEnabled: or('canUseSeatOverages', 'isOptedOutOfSeatBlocking'),
    canUseOutcomesRenaming: ComputedCanUseFeature('fin-enable-outcomes'),

    //team-self-serve
    hasIntercomHomeDevelopmentMode: ComputedCanUseFeature('intercom-home-development-mode'),
    canSeeProfilingSurvey: ComputedCanUseFeature('team-activation-profiling-survey'),
    canUseGlobalSearch: ComputedCanUseFeature('team-product-guidance-global-search'),
    canSeeChurnBanner: ComputedCanUseFeature('team-self-serve-churn-banner'),
    canAccessSelfServeRestartSubscriptionWipModal: ComputedCanUseFeature(
      'team-self-serve-churn-save-restart-subscription-temporary-ff-wip',
    ),
    hideGlobalTrialBanner: ComputedCanUseFeature('team-expansion-hide-global-trial-banner'),
    teamPurchaseExperienceTrialExtensionsVariant: ComputedCanUseFeature(
      'team-purchase-experience-trial-extensions-variant',
    ),
    teamPurchaseExperienceTrialExtensionsControl: ComputedCanUseFeature(
      'team-purchase-experience-trial-extensions-control',
    ),
    disableFrontendAddressValidation: ComputedCanUseFeature(
      'team-purchase-experience-disable-address-validation',
    ),
    canSeeFinIncentiveOffer: ComputedCanUseFeature('team-self-serve-fin-incentives'),
    canUseFinEmailBranding: ComputedCanUseFeature('team-self-serve-fin-email-branding'),
    shouldHideCancelationSurvey: ComputedCanUseFeature(
      'team-self-serve-hide-cancelation-survey-for-select-customers',
    ),
    canSeeAiInsightsAddon: ComputedCanUseFeature('team-self-serve-ai-insights-addon'),
    isForcedFreeSeatsCampaignEnrolment: ComputedCanUseFeature(
      'team-self-serve-force-free-seats-campaign',
    ),

    //team-messenger
    canUseConditionalDisplayForVisitors: ComputedCanUseFeature(
      'visitor_messenger_conditional_display',
    ),
    canUseNewVamPredicates: ComputedCanUseFeature('messenger-new-vam-predicates'),
    hasTargetInboundConversationsFeature: ComputedCanUseFeature('target_inbound_conversations'),
    canUseUnbrandedMessenger: ComputedCanUseFeature('unbranded'),
    canUseNews: ComputedCanUseFeature('news'),
    canUseNewsPathPrefixForCustomDomain: ComputedCanUseFeature(
      'news_path_prefix_for_custom_domain',
    ),
    canUseSalesPreview: ComputedCanUseFeature('team-mobile-sales-preview'),
    canSearchBrowseWithoutHelpSpace: ComputedCanUseFeature('search-browse-without-help-space'),
    canUseIdvEnabledSignUp: ComputedCanUseFeature(
      'team-messenger-idv-enabled-on-signup-experiment-candidate',
    ),
    isNewInstallationPageCandidate: ComputedCanUseFeature(
      'team-messenger-messenger-install-page-experiment-candidate',
    ),
    hasNewMessengerInstallationPage: or('canUseIdvEnabledSignUp', 'isNewInstallationPageCandidate'),
    canUseAliasNames: ComputedCanUseFeature('team-messenger-admin-alias'),
    canUseMultipleIdvSecrets: ComputedCanUseFeature('workstream-idv-cycling'),
    canUseJwtSecuritySettings: ComputedCanUseFeature('messenger-jwt-security-settings'),
    canUseMobileJwtSecuritySettings: ComputedCanUseFeature(
      'team-messenger-mobile-jwt-security-settings',
    ),
    canManageDeviceTokens: ComputedCanUseFeature('team-messenger-manage-device-tokens'),
    hideQuickReplies: computed('features.[]', 'localStorageFeatures.[]', function () {
      return (
        this.canUseFeature('answerbot-conversational-fin') &&
        (this.canUseFeature('answerbot-conversational-opt-in') ||
          !this.canUseFeature('answerbot-conversational-fin-opt-out'))
      );
    }),
    messengerCustomFonts: ComputedCanUseFeature('messenger-custom-fonts-pirateship'),

    //team-operator
    canUseOperatorQualifications: ComputedCanUseFeature('operator_qualification'),
    canUseVisitorAutoMessaging: ComputedCanUseFeature('visitor_auto_messaging'),
    canUseAppsInOperator: ComputedCanUseFeature('apps_in_operator'),
    hasHelpCenter: ComputedCanUseFeature('help_center'),
    hasEmbeddedArticles: ComputedCanUseFeature('embedded_articles'),
    canUseArticleAudienceTargeting: ComputedCanUseFeature('article_audience_targeting'),
    canUseWorkflowsNetNewExperience: ComputedCanUseFeature('workflows-net-new-experience'),
    hasVolumeControlPredictedAssignmentDeprecated: ComputedCanUseFeature(
      'predicted-assignment-volume-control-deprecated',
    ),
    hasFinIdentity: ComputedCanUseFeature('fin-identity'),
    canUseConversationAttributeChangedWorkflows: ComputedCanUseFeature(
      'conversation-attribute-changed-workflows',
    ),
    canUseAiSentimentAnalysis: ComputedCanUseFeature('ai-sentiment-analysis'),
    canUseCollectableDatetimeAttributes: ComputedCanUseFeature('collectable-datetime-attributes'),
    canUseFinAiCategories: ComputedCanUseFeature('team-workflows-fin-ai-routing'),
    canUseFinFirstAiCategories: ComputedCanUseFeature('fin-first-ai-categories'),
    canUseSdrInformationArchitectureChange: ComputedCanUseFeature(
      'sdr-information-architecture-change',
    ),
    canUseFinSalesAgent: ComputedCanUseFeature('fin-sales-agent'),
    canUseFinEcommerceAgent: ComputedCanUseFeature('fin-ecommerce-agent'),
    canUseEcommerceNewBusinessLaunch: ComputedCanUseFeature('ecommerce-new-business-launch'),
    canUseFinSuccessAgent: ComputedCanUseFeature('fin-success-agent'),
    canEnableComposerWhileWaitingForRating: ComputedCanUseFeature(
      'enable-composer-while-waiting-for-rating',
    ),
    canUseWorkflowDraftStateForInbound: ComputedCanUseFeature('workflow-draft-state-for-inbound'),
    canUseGuidanceAppliedPredicate: ComputedCanUseFeature(
      'team-ai-agent-guidance-applied-predicate',
    ),
    canUseKnownComparisonForListPredicates: computed(
      'features.[]',
      'localStorageFeatures.[]',
      function () {
        return (
          this.canUseFeature('team-workflows-fin-ai-routing') ||
          this.canUseFeature('ai-conversation-classification')
        );
      },
    ),
    canUseInboundBotsSansReplyButtons: ComputedCanUseFeature('inbound-bots-sans-reply-buttons'),
    canUseMultilingualWorkflows: ComputedCanUseFeature('multilingual-workflows'),

    //team-ai-insights
    canSeeAiTopics: computed('features.[]', 'localStorageFeatures.[]', function () {
      return (
        this.canUseFeature('ai_topics') || this.canUseFeature('team-self-serve-ai-insights-addon')
      );
    }),
    canSeeTrends: computed('features.[]', 'localStorageFeatures.[]', function () {
      return (
        this.canUseFeature('trends') || this.canUseFeature('team-self-serve-ai-insights-addon')
      );
    }),
    canSeeCxScore: computed('features.[]', 'localStorageFeatures.[]', function () {
      return (
        this.canUseFeature('cx_score') || this.canUseFeature('team-self-serve-ai-insights-addon')
      );
    }),
    canSeeOptimize: computed('features.[]', 'localStorageFeatures.[]', function () {
      return (
        this.canUseFeature('optimize') || this.canUseFeature('team-self-serve-ai-insights-addon')
      );
    }),
    canSeeSuggestions: computed('features.[]', 'localStorageFeatures.[]', function () {
      return (
        this.canUseFeature('suggestions') || this.canUseFeature('team-self-serve-ai-insights-addon')
      );
    }),
    canUseSuggestions: ComputedCanUseFeature('suggestions'),
    canSeeAiInsightsSummaries: computed('features.[]', 'localStorageFeatures.[]', function () {
      return (
        this.canUseFeature('ai_topics') && this.canUseFeature('ai-insights-summary-service-ui')
      );
    }),
    canSeeOptimizeCXScore: ComputedCanUseFeature('ai-insights-see-optimize-cx-score'),
    canSeeUpdatedImpactRankingForSuggestions: ComputedCanUseFeature(
      'ai-insights-updated-impact-ranking-for-suggestions',
    ),
    //team-reporting
    isOnCsvBlockedList: ComputedCanUseFeature('csv-import-blockedlist'),
    canUseOperatorTeammateFilter: ComputedCanUseFeature('operator-teammate-filter'),

    isOptedOutOfSeatBlocking: ComputedCanUseFeature('team-people-seat-blocking-opt-out'),
    teammateTableDynamicQueries: ComputedCanUseFeature('teammate-table-dynamic-queries'),
    canSeeMetricsPlayground: ComputedCanUseFeature('reporting-metrics-playground'),
    canUseGoogleAnalytics4Integration: ComputedCanUseFeature('google-analytics-4-integration'),
    canUseTopicFilter: readOnly('hasConversationalInsightsBillingFeature'),

    hasConversationalInsightsBillingFeature: ComputedCanUseFeature('conversational_insights'),
    hasConverationalInsightsIntegrationExplicitlyDisabled: ComputedCanUseFeature(
      'insights-conversational-insights-disable-inbox-integration',
    ),
    hasCustomReportsBillingFeature: ComputedCanUseFeature('custom_reports'),
    canUseSyntheticReportingData: ComputedCanUseFeature('reporting-synthetic-data'),
    canSeeFullR2Experience: ComputedCanUseFeature('reporting-r2-full-experience'),
    cannotSeeDeprecatedReports: computed('features.[]', 'localStorageFeatures.[]', function () {
      return (
        this.canUseFeature('reporting-no-deprecated-reports') ||
        this.canUseFeature('reporting-r2-full-experience')
      );
    }),
    canSeeAiCsatMetrics: ComputedCanUseFeature('ai-insights-ai-csat-metrics'),
    canSeeNewChartLayout: ComputedCanUseFeature('reporting-new-chart-layout'),
    cannotSeeCSOverviewReport: ComputedCanUseFeature('reporting-no-cs-overview-report'),
    hasDeprecatedCSOverviewReport: ComputedCanUseFeature('reporting-deprecate-cs-overview-report'),
    //team-inbox billing
    canUseConversationRatings: ComputedCanUseFeature('conversation_ratings'),
    canUseInboxSlas: ComputedCanUseFeature('inbox_conversation_sla_rules'),
    canUseTinyMinimumSlaDuration: ComputedCanUseFeature('tiny-minimum-sla-duration'),
    canUsePriorityRules: ComputedCanUseFeature('inbox_priority_rules'),
    canUseTagRules: ComputedCanUseFeature('inbox_conversation_tag_rules'),

    //team-inbox features
    canSeeSnowfall: ComputedCanUseFeature('respond-inbox-of-love-snowflakes'),
    canUseSavedRepliesFuzzySearch: ComputedCanUseFeature('team-inbox-saved-replies-fuzzy-search'),
    canUseInboxSearchInViews: ComputedCanUseFeature('inbox-search-in-views'),
    canSnoozeByHours: ComputedCanUseFeature('team-inbox-can-snooze-by-hours'),
    canUseEmailNotificationDestinationUrl: ComputedCanUseFeature(
      'email-notification-destination-url',
    ),
    canAssignToTeamAndTeammate: true,
    canUseDisableNotificationForRepliesToUnassigned: ComputedCanUseFeature(
      'disable-notification-for-replies-to-unassigned',
    ),
    canUseElasticsearchInboxes: ComputedCanUseFeature('es-inboxes'),
    canUseCustomAddressPermission: ComputedCanUseFeature('custom-address-permission'),

    canOverrideSenderOnOsc: ComputedCanUseFeature('inbox_override_sender_on_osc'),
    canUseSLAAdvanceWarningTrigger: ComputedCanUseFeature('sla-breach-advance-warning-trigger'),
    canUseSlackChannelInput: ComputedCanUseFeature('team-collaboration-slack-notifications-input'),
    canNotifyPrivateSlackChannel: ComputedCanUseFeature('notify-private-slack-channel'),
    canUseSlackLegacyApp: ComputedCanUseFeature('dev-platform-legacy-slack-integration'),
    excludeTicketsBalancedAssignment: ComputedCanUseFeature('filter-tickets-balanced-assignment'),

    //team-inbox features
    canUseWorkloadManagement: readOnly('workloadManagementEnabled'),
    canUseAwaitingFirstReplyTrigger: ComputedCanUseFeature(
      'inbox_rules_awaiting_first_reply_event',
    ),
    hasMacros: ComputedCanUseFeature('macros_with_actions_billing_feature'),
    canUseMacros: reads('hasMacros'),
    canUseRoleCapacity: ComputedCanUseFeature('team-support-retain-role-level-capacity'),
    canSetMacroVisibility: ComputedCanUseFeature('team_macros'),
    hasRealtimeMonitoring: ComputedCanUseFeature('realtime_monitoring'),
    canSeeConversationsPerHourMetric: ComputedCanUseFeature(
      'team-sops-realtime-conversations-per-hour',
    ),
    canSeeReassignAction: ComputedCanUseFeature('team-sops-reassign-action'),

    canUseLbaTagMatch: ComputedCanUseFeature('lba-tag-match'),
    canUseDisableEmailReassignment: ComputedCanUseFeature('team-sops-wlm-stop-email-reassignment'),
    canEditTicketDesciptionDescriptions: ComputedCanUseFeature(
      'edit-ticket-description-descriptions',
    ),
    canSkipTicketsPortalIdvRequirement: ComputedCanUseFeature(
      'skip-tickets-portal-idv-requirement',
    ),
    // team-ai-agent
    canUseFinThumbsDown: ComputedCanUseFeature('fin-thumbs-down'),
    canUseFinGuidance: ComputedCanUseFeature('fin-guidance-closed-beta'),
    canUseThemeBasedRollout: ComputedCanUseFeature('ai-agent-theme-based-rollout'),
    canUseFinGuidanceReusablePreview: ComputedCanUseFeature('fin-guidance-use-reusable-preview'),
    canUseFinPreviewImpersonation: ComputedCanUseFeature('fin-preview-impersonation'),
    canUseFinPreviewAutoLanguageDetection: ComputedCanUseFeature(
      'fin-preview-auto-language-detection',
    ),
    canUseFinE2EPreview: ComputedCanUseFeature('ai-agent-fin-e2e-preview'),
    canUseEmailPreviewInbox: ComputedCanUseFeature('ai-agent-email-preview-inbox'),
    canUseFinEmailPreviewReact: ComputedCanUseFeature('fin-email-preview-react'),
    canUseAllAttributesInAIAudiences: ComputedCanUseFeature('all-attributes-in-ai-audiences'),
    canUseMBFAiAgentIdentities: ComputedCanUseFeature('mbf-ai-agent-identities'),
    canUseMultiBrandGA: ComputedCanUseFeature('multi-brand-for-fin-ga'),
    canUseCustomCsatMessageAfterFin: ComputedCanUseFeature(
      'rd-services-custom-csat-message-after-fin',
    ),
    canUseAccessFinAndAutomationSettingsPermission: ComputedCanUseFeature(
      'access-fin-and-automation-settings-permission',
    ),
    canOnlyShowOneFinDeploy: ComputedCanUseFeature('fin-first-only-show-one-fin-deploy-method'),
    canUseNewWorkflowChannelSetupBanner: ComputedCanUseFeature(
      'team-ai-agent-new-workflow-channel-setup-banner',
    ),

    //team-ai-agent-2
    canUseBatchTestEscalationMessage: ComputedCanUseFeature(
      'answerbot-playground-disable-human-available',
    ),
    canUseAudiencesInPreview: ComputedCanUseFeature('fin-preview-audience'),
    canUseStandaloneE2EPreview: ComputedCanUseFeature('standalone-e2e-preview'),

    // team-inbox features
    canUsePerWorkspaceAdminAvatars: ComputedCanUseFeature('team-inbox-per-workspace-admin-avatars'),
    canUseAiAssistAutoFillTickets: ComputedCanUseFeature('ai_assist_auto_fill_tickets'),
    canUseAiConversationClassification: ComputedCanUseFeature('ai-conversation-classification'),
    canByPassMultibrandPaywall: ComputedCanUseFeature('multibrand-ignore-paywall'),
    canUseMultibrandBillingFeature: ComputedCanUseFeature('messenger_multibrand'),
    canUseMultibrandEmailBrandSda: ComputedCanUseFeature('multibrand-email-brand-sda'),
    hasBeenOnMultibrandBeta: ComputedCanUseFeature('has-been-on-multibrand-beta'),
    canViewMultilingualGlossaryPage: ComputedCanUseFeature('multilingual-glossary-page'),
    canViewAiTranslationPricing: ComputedCanUseFeature('multilingual-ai-translation-pricing'),
    canManageSharedCustomFolders: ComputedCanUseFeature('inbox-shared-custom-folders'),
    canManageInboxViewsPinnedColumns: ComputedCanUseFeature('inbox-views-pinned-columns'),
    canDeleteUserNotes: ComputedCanUseFeature('spg-inbox-delete-user-notes-permission'),
    canSplitRedactConversationPartsPermission: ComputedCanUseFeature(
      'spg-inbox-split-redact-conversation-parts-permission',
    ),
    canManageTeamAndTeammateLevelAccess: computed(function () {
      return true;
    }),
    canUseRestrictVisibilityOfTicketsToUsers: ComputedCanUseFeature(
      'spg-tickets-portal-restrict-to-user-tickets',
    ),
    canUseTicketsPortalFullContentSearch: ComputedCanUseFeature(
      'psg-tickets-portal-full-content-search',
    ),
    canUseRequiredTicketAttributesOnClose: ComputedCanUseFeature(
      'spg-inbox-required-ticket-attributes-on-close',
    ),

    // team-ml features
    hasAnswerBot: ComputedCanUseFeature('answer_workflows'),
    hasDetailedActivityTracking: ComputedCanUseFeature('ember-ml-detailed-activity-tracking'),
    hasSampledActivityTracking: ComputedCanUseFeature('ember-ml-sampled-activity-tracking'),
    canUseFinCustomStep: ComputedCanUseFeature('fin-custom-step'),
    canUseFinCustomImageRecognition: ComputedCanUseFeature(
      'answerbot-fin-custom-image-recognition',
    ),

    //BILLING:
    hasMultipleLanguages: ComputedCanUseFeature('multiple_language_support'),
    canUseRotatingAssignment: ComputedCanUseFeature('round_robin'),
    canUseFree: ComputedCanUseFeature('ember-purchase-free'),
    canUseRevenueReports: ComputedCanUseFeature('revenue_reports'),
    canUseCSVExport: ComputedCanUseFeature('inbox_csv_export'),
    workloadManagementEnabled: ComputedCanUseFeature('manage_capacity'),
    canUseBranchingQualification: ComputedCanUseFeature('branching_qualification'),
    canUseConversationRouting: ComputedCanUseFeature('conversation_routing'),
    hasAccountMarketingBillingFeature: ComputedCanUseFeature('account_marketing'),
    hasUpfrontEmailCollectionBillingFeature: ComputedCanUseFeature('upfront_email_collection'),
    hasDynamicAccountMessagesBillingFeature: ComputedCanUseFeature('dynamic_account_messages'),
    hasSalesforceSandboxFeatureInPlan: ComputedCanUseFeature('salesforce_sandbox'),
    canUseEmailForwarding: computed(
      'features.[]',
      'localStorageFeatures.[]',
      'products.[]',
      function () {
        return this.canUseFeature('email_forwarding');
      },
    ),

    canUseInboxRules: ComputedCanUseFeature('inbox_rules'),
    hasDefaultSenderAddress: ComputedCanUseFeature('default_sender_address'),

    //design systems
    canUseHasFeatureTest: ComputedCanUseFeature('has-feature-test-feature'),

    //team-app-security
    canSeeReactPersonalPreferences: ComputedCanUseFeature(
      'team-app-security-react-personal-preferences',
    ),
    canSkipSsoCleanupOnEmailChange: ComputedCanUseFeature(
      'app-security-skip-email-change-sso-account-clean-up',
    ),
    canUseSecurityHealthCheck: ComputedCanUseFeature('team-app-security-health-check'),
    canUseWorkflowConnectorIdentityPolicy: ComputedCanUseFeature(
      'workflow-connector-edit-identity-policy',
    ),
    canUseWorkflowConnectorUseIdentityPolicy: ComputedCanUseFeature(
      'workflow-connector-use-identity-policy',
    ),

    // team-conversations
    isForbiddenFromUsingUserPresenceService: ComputedCanUseFeature(
      'ember-conversations-is-forbidden-from-using-user-presence-service',
    ),

    // team-channels
    canUseSwitchStatusFilter: ComputedCanUseFeature('switch-status-filter'),
    useWhatsappCloudApi: ComputedCanUseFeature('whatsapp-cloud-api'),
    canUseWhatsappOutbound: computed(
      'features.[]',
      'localStorageFeatures.[]',
      'products.[]',
      function () {
        return (
          this.canUseFeature('whatsapp_integration') &&
          this.canUseFeature('whatsapp_outbound_billing_feature')
        );
      },
    ),
    enableTwitterIntegration: ComputedCanUseFeature('enable-twitter-integration'),
    enableTwitterIntegrationBots: ComputedCanUseFeature('enable-twitter-integration-bots'),
    canUseRoleSidebarSectionConfiguration: ComputedCanUseFeature(
      'team-email-sidebar-section-configuration',
    ),

    // team-standalone
    canUseStandalone: readOnly('isStandaloneApp'),
    canUseStandaloneSalesforceCopilot: ComputedCanUseFeature('team-standalone-copilot-salesforce'),
    canUseStandaloneZendeskCopilotEarlyAccess: ComputedCanUseFeature(
      'team-standalone-zendesk-copilot-early-access',
    ),
    canUseStandaloneSalesforceCopilotEarlyAccess: ComputedCanUseFeature(
      'team-standalone-salesforce-copilot-early-access',
    ),
    canUseStandaloneDeployPhone: ComputedCanUseFeature('team-standalone-deploy-phone'),
    canUseFinStandaloneRedirectFromSuite: ComputedCanUseFeature(
      'enable-fin-standalone-redirect-from-suite',
    ),
    canOptOutOfFinStandaloneRedirectFromSuite: ComputedCanUseFeature(
      'enable-fin-standalone-redirect-from-suite-opt-out',
    ),
    canUseReusableWorkflowsInStandalone: ComputedCanUseFeature(
      'team-standalone-reusable-workflows',
    ),
    canUseEnglishVariations: ComputedCanUseFeature('language-support-english-versions'),
    allowAccessOutsideStandaloneSection: computed(
      'features.[]',
      'localStorageFeatures.[]',
      'isMigratingFromStandaloneToSuite',
      function () {
        return (
          this.canUseFeature('team-standalone-allow-access-outside-standalone-section') ||
          this.isMigratingFromStandaloneToSuite
        );
      },
    ),
    // we currently leave this feature flag enabled during and after the migration to suite
    hasStandaloneToSuiteMigrationFeature: ComputedCanUseFeature(
      'team-standalone-migrating-from-standalone-to-suite',
    ),
    canShowManageMigration: reads('isMigratingFromStandaloneToSuite'),
    canUseExternalArticlesAsFinContent: ComputedCanUseFeature(
      'ai-allow-external-articles-as-fin-content',
    ),
    canUseFinInOutboundDropdown: ComputedCanUseFeature('customer-agent-fin-outbound'),
    canUseHandoffToSalesforceChat: ComputedCanUseFeature(
      'team-standalone-handoff-to-salesforce-chat',
    ),
    canChangeContentImportState: ComputedCanUseFeature(
      'team-standalone-change-content-import-state',
    ),
    canUseSunshineQueueInformationMessage: ComputedCanUseFeature(
      'team-standalone-sunshine-queue-information-message',
    ),
    canUseUpdatedLauncherPredicates: ComputedCanUseFeature(
      'team-standalone-updated-launcher-predicates',
    ),
    canUseMoreAttachmentTypesInStandalone: ComputedCanUseFeature(
      'team-standalone-more-attachment-types',
    ),
    canSeeFinReportsWithoutConversationSyncing: ComputedCanUseFeature(
      'team-standalone-fin-reports-without-conversation-syncing',
    ),
    canSeeDataSecurityInStandalone: ComputedCanUseFeature('team-standalone-data-security-settings'),
    canUseZendeskOAuth: ComputedCanUseFeature('team-standalone-zendesk-oauth'),
    canUseZendeskTicketsNewIA: ComputedCanUseFeature('team-standalone-zendesk-tickets-new-ia'),
    canUseZendeskMultiEnv: ComputedCanUseFeature('team-standalone-zendesk-multi-env'),
    canUseSunshineOAuth: ComputedCanUseFeature('team-standalone-sunshine-oauth'),
    canUseConfirmResolution: ComputedCanUseFeature('team-standalone-confirm-resolution'),
    hasStandaloneMultiEnvFeature: ComputedCanUseFeature('team-standalone-multi-environment'),
    canUseReactFreshdeskDeployPages: ComputedCanUseFeature(
      'team-standalone-react-freshdesk-deploy-pages',
    ),
    canUseStandaloneMultiEnv: computed(
      'hasStandaloneMultiEnvFeature',
      'canUseStandalone',
      'hasStandalonePlatform',
      function () {
        return (
          this.canUseStandalone &&
          this.hasStandaloneMultiEnvFeature &&
          !(
            this.hasStandalonePlatform(StandalonePlatform.Zendesk) ||
            this.hasStandalonePlatform(StandalonePlatform.ZendeskLite) ||
            this.hasStandalonePlatform(StandalonePlatform.Freshdesk) ||
            this.hasStandalonePlatform(StandalonePlatform.CustomHelpdesk) ||
            this.hasStandalonePlatform(StandalonePlatform.Unknown)
          )
        );
      },
    ),
    canUseStandaloneConnectPage: computed(
      'canUseStandaloneMultiEnv',
      'standalone_platforms.[]',
      'canUseReactFreshdeskDeployPages',
      function () {
        return (
          this.canUseStandaloneMultiEnv ||
          this.hasStandalonePlatform(StandalonePlatform.Salesforce) ||
          (this.hasStandalonePlatform(StandalonePlatform.Freshdesk) &&
            this.canUseReactFreshdeskDeployPages) ||
          this.hasStandalonePlatform(StandalonePlatform.Front)
        );
      },
    ),
    canUseSalesforceDigitalExperience: computed(
      'canUseStandalone',
      'hasStandalonePlatform',
      function () {
        return this.canUseStandalone && this.hasStandalonePlatform(StandalonePlatform.Salesforce);
      },
    ),

    canUseStripeAppCreateUserWithMetadata: ComputedCanUseFeature(
      'df-stripe-integration-create-user-with-metadata',
    ),

    featureIdsSet: computed('features.[]', function () {
      let features = this.features || [];
      return new Set(features.map((feature) => feature.id));
    }),

    canUseFeatureWithoutLocalOverrides(featureIdentifier) {
      return this.canUseFeature(featureIdentifier, false);
    },
    canUseFeature(featureIdentifier, allowLocalOverrides = true) {
      let appId = this.id;
      if (this.isDestroyed || this.isDestroying) {
        return false;
      }

      if (IntercomradesProductsOverride.isEnabled(appId)) {
        return IntercomradesProductsOverride.features(this).includes(featureIdentifier);
      } else {
        return (
          (allowLocalOverrides && this.localStorageFeatures.includes(featureIdentifier)) ||
          (this.featureIdsSet && this.featureIdsSet.has(featureIdentifier))
        );
      }
    },
    // Alias for compatiability with the workspace model
    isFeatureEnabled(featureIdentifier) {
      return this.canUseFeature(featureIdentifier);
    },

    // team-frontend-tech
    canUseNexusEnhancedLogging: ComputedCanUseFeature('nexus-enhanced-logging'),

    // team-billing
    usagePageTweaksForFinBuckets: ComputedCanUseFeature(
      'billing-usage-page-tweaks-for-fin-buckets',
    ),

    // team-fin-nux
    canShowNewPersonalityComponent: ComputedCanUseFeature('team-fin-nux-new-personality-component'),
    customAnswersAreDeprecated: ComputedCanUseFeature('deprecated-custom-answers'),

    // team-omni
    canUseSlack: ComputedCanUseFeature('team-omni-slack'),
    canUseDiscordChannel: ComputedCanUseFeature('discord-channel'),
    canUseOmniHostedTicketForms: ComputedCanUseFeature('omni-hosted-ticket-forms'),

    canUseFinAgentApi: ComputedCanUseFeature('fin-agent-api'),

    // default-ff-tests do not change or activate in prod env
    testFeatureEnabledByGlobalFeatureFlagDefaults: ComputedCanUseFeature(
      nameForTestFeatureEnabledByGlobalFeatureFlagDefaults,
    ),
    testFeatureDisabledByGlobalFeatureFlagDefaults: ComputedCanUseFeature(
      nameForTestFeatureDisabledByGlobalFeatureFlagDefaults,
    ),

    init() {
      this._super(...arguments);
      this.refreshLocalStorageFeatures();
    },
    refreshLocalStorageFeatures() {
      this.set('localStorageFeatures', localFeatureFlags.list());
    },
    addLocalStorageFeature(featureKey) {
      localFeatureFlags.add(featureKey);
      this.refreshLocalStorageFeatures();
    },
    removeLocalStorageFeature(featureKey) {
      localFeatureFlags.remove(featureKey);
      this.refreshLocalStorageFeatures();
    },
  };
};

export default Mixin.create(generateFeatureFlagConfig());

// this list only includes features from the above config generation that have
// a direct call to ComputedCanUseFeature(). it DOES NOT include complex
// computed() fields, unless the feature names used inside the computed happen
// to also have sibling static flags using ComputedCanUseFeature()
export const ALL_STATIC_FEATURE_FLAG_NAMES = Object.values(
  generateFeatureFlagConfig({ flattenComputed: true }),
).filter((value) => typeof value === 'string');
